var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-button",attrs:{"id":"logo"}},[_c('a',{attrs:{"href":"https://miastojestnasze.org","target":"_blank"}},[_c('img',{attrs:{"src":require('../assets/mjn_logo_pionowe.svg'),"alt":"Miasto Jest Nasze"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }